import React, { useState } from "react";

import { UploadState } from "../modules/header/upload.reducer";
import { HandleUploadParams, LayoutType } from "./@types";
import ModalWrapper from "./ModalWrapper";
import FileAnalysisForm from "./file-analysis-form/FileAnalysisForm";
import { LAYOUT_TYPE } from "./file-analysis-form/consts";

type FileAnalysisModalProps = {
  showModal: boolean;
  closeModal: () => void;
  handleUpload: (args: HandleUploadParams) => void;
  state: UploadState;
};

const FileAnalysisModal: React.FC<FileAnalysisModalProps> = ({
  showModal,
  closeModal,
  handleUpload,
  state
}) => {
  const [layoutType, setLayoutType] = useState<LayoutType>(LAYOUT_TYPE.XL);

  return (
    <ModalWrapper
      show={showModal}
      title="File Analysis"
      size={layoutType}
      onHide={closeModal}
      className="file-analysis-modal"
      preventOtherActions
    >
      <FileAnalysisForm
        closeModal={closeModal}
        handleUpload={handleUpload}
        onLayout={setLayoutType}
        state={state}
      />
    </ModalWrapper>
  );
};

export default FileAnalysisModal;
